import { IWixAPI } from '@wix/native-components-infra/dist/src/types/types';

export const currentLanguage = (wixCodeApi: IWixAPI) => {
  const locale = wixCodeApi.site.language;
  const localeToSubstring = locale ? locale.substring(0, 2) : undefined;
  return localeToSubstring || 'en';
};
